import { useQuery } from "@tanstack/react-query";
import { SHOWIT_LIBRARY_DESIGNS } from "../../constants/QueryKeys";
import LibraryService from "../../service/LibraryService";
import { STATIC_QUERY_DEFAULTS } from "../../utils/QueryUtils";

/** @typedef {import("@/types/services/LibraryServiceTypes.mjs").SiteConfig} SiteConfig */
/** @typedef {{ response: number, sites: SiteConfig[] }} ShowitLibraryDesignsData */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = { ...STATIC_QUERY_DEFAULTS, enabled: false };

/** Key + fetcher for the Showit design library; imperative callers spread this into fetchQuery. */
export const showitLibraryDesignsQuery = {
  queryKey: [SHOWIT_LIBRARY_DESIGNS],
  queryFn: () => LibraryService.loadSites(),
  staleTime: Infinity,
};

/**
 * The Showit design library (disabled until a caller enables or refetches it).
 * @param {QueryHookOptions<ShowitLibraryDesignsData>} [options] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ showitLibDesigns: SiteConfig[] | undefined } & QueryResultRest<ShowitLibraryDesignsData>}
 */
const useShowitLibraryDesigns = (options = {}) => {
  const { data, ...rest } = useQuery({
    ...showitLibraryDesignsQuery,
    ...defaults,
    ...options,
  });
  return { showitLibDesigns: data?.sites, ...rest };
};

export default useShowitLibraryDesigns;
